// extracted by mini-css-extract-plugin
module.exports = {"AnswersList":"AnswersList_AnswersList__y9_B4"};